export const ROUTES = {
  CAMPAIGNS: '/campaigns',
  DASHBOARD: '/dashboard',
  DISPOSITIONS: '/dispositions',
  CLIENTS: '/clients',
  FIELDS: '/fields',
  HOME: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  LOGGEDOUT: '/loggedout',
  PROSPECTS: '/prospects',
  PROSPECTS_IMPORTS: '/prospects/imports',
  USERS: '/users',
}
